'use strict';

const lodashFlattenDeep = require('lodash.flattendeep');
const SV = require('server-vars');

/**
 * Checks is current page type in arguments list.
 * Page types are defined in global/costants/pageTypes.es.js
 *
 * isPageType('browse', 'home', ['pdp', 'attribute'], ['creator']);
 *
 * @return {boolean}
 */
const pageTypeHelper = {
    isPageType() {
        const pageType = SV.get('settings.pageType');

        return lodashFlattenDeep(arguments).indexOf(pageType) > -1;
    }
};

module.exports = pageTypeHelper;



// WEBPACK FOOTER //
// ./assets/js/global/notifications/pageTypeHelper.es.js